import { AnalyticsBrowser } from '@segment/analytics-next'
import { IStudio } from '../apilibrary/types/studio';
import userCurrentUserId from '../hooks/useCurrentUserId';

// TODO: refactor to take some env variable and switch write keys based on stage - this is fine for testing beta now
export const analytics = AnalyticsBrowser.load({ writeKey: 'coZeiJO3LbNioOzZQmBSsr1fruY5F4Hd' });

export async function trackUserIdentify (userId: string | undefined): Promise<void> {
  if (userId !== undefined) {
    await analytics.identify(userId)
  } else {
    await analytics.identify(anonymousId)
  }
}

export async function trackUserSignUpConfirmed (): Promise<void> {
  await analytics.track('Sign Up Confirmed', {
    anonymousId
  });
}

export async function trackUserSignUpFailed (): Promise<void> {
  await analytics.track('Sign Up Confirmation Failed', {
    anonymousId
  });
}

export const anonymousId = async (event: any = {}): Promise<any> => {
  const anonId = (await analytics.user()).anonymousId();

  return anonId?.toString
}

export async function trackStudioView (studio: IStudio): Promise<void> {
  await analytics.track('Studio Viewed', {
    studioName: studio.info.title
  });
}

export async function trackBookingInteraction (startTime: string, endTime: string, startDate: string, endDate: string, studioId: string, requesterId: string): Promise<void> {
  await analytics.track('Studio Booking Component Viewed', {
    startTime,
    endTime,
    startDate,
    endDate,
    studioId,
    userId: requesterId
  });
}

export async function trackUserSignUpClick (): Promise<void> {
  await analytics.track('Sign Up Button Clicked', {
    userId: userCurrentUserId(),
    anonymousId
  });
}

export async function trackProfileView (userId: string): Promise<void> {
  await analytics.track('Profile Viewed', {
    ownerId: userId
  });
}

export async function trackValidSpotifyLink (spotifyLinkId: string, profileUserId: string): Promise<void> {
  await analytics.track('Valid Spotify Link Inputted', {
    spotifyPlaylistId: spotifyLinkId,
    ownerId: profileUserId
  });
}

export async function trackProfilePictureUpdate (profilePictureUrl: string, profileUserId?: string): Promise<void> {
  await analytics.track('Profile Picture Updated', {
    ownerId: profileUserId,
    profilePictureUrl
  });
}

export async function trackStudioDeletion (studioId: string, userId?: string): Promise<void> {
  await analytics.track('Studio Deleted', {
    studioId,
    ownerId: userId
  });
}

export async function trackStudioUpdate (studioTitle: string, ownerId: string): Promise<void> {
  await analytics.track('Studio Updated', {
    sutdioName: studioTitle,
    ownerId
  });
}

export async function trackUserProfileUpdate (firstName: string, lastName: string, userId: string): Promise<void> {
  await analytics.track('User Profile Updated', {
    firstName,
    lastName,
    userId
  });
}

export async function trackSetupPayoutDetails (userId?: string): Promise<void> {
  await analytics.track('Payout Details Setup Button Clicked', {
    userId
  });
}

export async function trackStudioCreation (studioId: string, ownerId: string): Promise<void> {
  await analytics.track('Studio Listing Created', {
    studioId,
    ownerId
  });
}

export async function trackUserLoginFailure (userId: string | undefined): Promise<void> {
  await analytics.track('User Login Failed', {
    userId: userId !== undefined ? userId : anonymousId
  });
}

export async function trackUserLoginSuccess (userId: string | undefined): Promise<void> {
  await analytics.track('User Login Succeeded', {
    userId: userId !== undefined ? userId : anonymousId
  });
}

export async function trackUserLogout (userId: string | undefined): Promise<void> {
  await analytics.track('User Logged Out', {
    userId
  });

  await analytics.reset();
}
